import moment from 'moment';

const formatDatePickerTime = date => {
  //check(date, Match.OneOf(String, Date));
  return moment.utc(date, 'YYYY-MM-DD');
  /* console.log('date', date);
    console.log('moment(date, YYYY-MM-DD)', moment(date, 'YYYY-MM-DD'));
    console.log('moment.utc(date, YYYY-MM-DD)', moment.utc(date, 'YYYY-MM-DD'));
    return moment.utc(date, 'YYYY-MM-DD'); */
};

export default formatDatePickerTime;



// WEBPACK FOOTER //
// ./src/lib/helpers/GeneralHelpers/formatDatePickerTime.js